import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/contexts/LanguageContext";

const NotFound = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="page-404"
      className="mx-auto max-w-3xl px-5 sm:px-8 lg:px-12 py-32 text-center"
    >
      <span className="text-[11px] uppercase tracking-[0.22em] text-[#082133] font-semibold">
        404
      </span>
      <h1 className="mt-4 font-display font-semibold text-[#111111] text-[42px] sm:text-[56px] leading-[1.05] tracking-[-0.03em]">
        Page not found.
      </h1>
      <p className="mt-4 text-[16px] text-[#4B5563]">
        Looks like this page took a sabbatical on the Big Island. Let's get you home.
      </p>
      <div className="mt-10 inline-flex">
        <Link to="/">
          <Button
            data-testid="404-home-btn"
            className="rounded-full h-12 px-7 bg-[#082133] text-[#FAFAFA] hover:bg-[#0A2D47]"
          >
            {t("common.backHome")}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
